import { recipeCollections, recipes } from '@/data/mockData';
import { ChevronRight } from 'lucide-react';

interface RecipeCollectionsProps {
  onSelectCollection: (recipeIds: string[]) => void;
}

const RecipeCollections = ({ onSelectCollection }: RecipeCollectionsProps) => (
  <div>
    <h3 className="text-xs font-medium mb-1.5">Colecciones</h3>
    <div className="flex gap-2 overflow-x-auto pb-1 -mx-1 px-1 scrollbar-hide">
      {recipeCollections.map((col) => (
        <button
          key={col.id}
          onClick={() => onSelectCollection(col.recipeIds)}
          className="flex-shrink-0 bg-card rounded-lg p-2.5 shadow-card border border-border hover:border-primary/30 transition-colors min-w-[110px]"
        >
          <span className="text-base mb-0.5 block">{col.emoji}</span>
          <p className="text-[11px] font-semibold text-foreground leading-tight">{col.title}</p>
          <p className="text-[9px] text-muted-foreground mt-0.5">{col.recipeIds.length} recetas</p>
        </button>
      ))}
    </div>
  </div>
);

export default RecipeCollections;
